export const deClientPortalDashboardHistoryChart = {
    normalizedHistoryTooltip:
        'Relativ zeigt die Entwicklung als Like-for-like-Index. Berücksichtigt werden Wertänderungen von Immobilien, für die im ausgewählten Zeitraum in mehreren Jahren Werte vorliegen.',
}
